import { createContext } from 'react';

const MiniDialogModalTranslationsContext = createContext({
    closeDialog: 'Sluiten',
    generalNode: 'Algemeen',
    playDialog: 'Dialoog afspelen',
    stopDialog: 'Dialoog stoppen',
    example: 'Voorbeeld',
    ownVoice: 'Eigen stem',
    optionsTextAndSound: 'Opties tekst en geluid',
    optionsKeyWords: 'Kernwoorden',
    playTitle: 'Afspelen',
    pauseTitle: 'Pauzeren',
    recordTitle: 'Opname starten',
    stopRecordTitle: 'Opname stoppen',
    playRecordingTitle: 'Opname afspelen',
    pauseRecordingTitle: 'Opname pauzeren',
    hideTextTitle: 'Tekst verbergen',
    showTextTitle: 'Tekst tonen',
    hideKeywordsTitle: 'Kernwoorden verbergen',
    showKeywordsTitle: 'Kernwoorden tonen',
    muteTitle: 'Dempen',
    unmuteTitle: 'Dempen opheffen',
    errors: {
        browserSupport: 'Je browser ondersteunt de opnamefunctie niet voor deze minidialoog.',
        accessDenied: 'Je hebt de toegang tot je microfoon geweigerd. Daardoor kan er niet opgenomen worden. <a href="#">Meer weten.</a>',
        noMicrophone: 'Er is geen microfoon gevonden bij jouw apparaat.',
    },
});

export { MiniDialogModalTranslationsContext };
